import React, {Fragment} from "react";
import HtmlEditor from "./HtmlEditor";
import {useSelector} from "react-redux";
import CircleButton from "../buttons/CircleButton";

const options = {
    showPathLabel: true,
    charCounter: true,
    height: "100% !important",
    resizingBar: true,
    buttonList: [
        ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
        ['fontColor', 'hiliteColor', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'table'],
        ['link', 'fullScreen', 'showBlocks', 'codeView']
    ],
};

export default (props) => {

    const {value, handleChangeContent, handleSave, isEditorOpened, toggleEditorOpened} = props;
    const {isAdminAsPartner, isPartner} = useSelector(state => state.auth);
    const isLoggedAsPartner = isPartner || isAdminAsPartner;

    const buttons = () => {
        return (
            !isLoggedAsPartner
            &&
            <div className="circle-btn-group" style={{justifyContent: "flex-start"}}>
                <CircleButton iconClassName='ti ti-marker-alt' onClick={toggleEditorOpened} title='Редактировать' isSelected={isEditorOpened}/>
                {handleSave
                &&
                <CircleButton iconClassName='ti ti-save' onClick={handleSave} title='Сохранить изменения'/>
                }
            </div>
        )
    };

    const content = () => {
        return (
            <div className="tab-pane fade active show pl-3" id="custom-nav-home" role="tabpanel"
                 aria-labelledby="custom-nav-home-tab">
                {
                    isLoggedAsPartner || !isEditorOpened
                        ? <div dangerouslySetInnerHTML={{__html: value}}/>
                        : <Fragment>
                            <HtmlEditor onChange={handleChangeContent} initialContent={value} options={options}/>
                            <br/>
                        </Fragment>
                }
            </div>
        )
    };

    return (
        <Fragment>
            {buttons()}
            {content()}
        </Fragment>
    )
}